<template>
    <v-container fluid>
        <v-btn
            :loading="identitiesWithInfo === null"
            @click="newIdentity"
            bottom
            class="mb-10"
            color="secondary darken-1"
            fab
            fixed
            right
        >
            <v-icon>mdi-plus</v-icon>
        </v-btn>
        <v-row
            align="center"
            no-gutters
        >
            <v-col
                cols="12"
                justify="center"
                lg="4"
                sm="6"
            >
                <v-subheader>
                    <h2>Identities ({{totalMatches}})</h2>
                </v-subheader>
            </v-col>
            <v-col
                cols="12"
                lg="4"
                sm="6"
            >
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col
                class="text-right"
                cols="12"
                lg="4"
                sm="6"
            >
                <!--<v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>-->
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row
                justify="center"
                v-if="identitiesWithInfo === null"
            >
                <v-col
                    :key="i"
                    cols="12"
                    lg="6"
                    v-for="i in 6"
                >
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row
                justify="center"
                v-else
            >
                <v-col
                    :key="identityWithInfo.entity.id"
                    cols="12"
                    lg="6"
                    v-for="identityWithInfo in identitiesWithInfo"
                >
                    <!--@click="loadIdentityForm(identityWithInfo.entity)"-->
                    <v-card
                        @click="loadIdentityForm(identityWithInfo.entity)"
                        class="entity-card fill-height"
                        elevation="4"
                        style="overflow:hidden"
                    >
                        <v-card-title>
                            <h5>{{identityWithInfo.entity.name}} {{identityWithInfo.entity.surname}}</h5>
                        </v-card-title>
                        <v-card-subtitle>{{identityWithInfo.entity.identificationNumber}}</v-card-subtitle>

                        <div>
                            <v-card-text class="center-content pa-2">
                                <v-row justify="space-around">
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    >
                                        <v-card
                                            @click.stop="if(identityWithInfo.entity.idDocumentFileId > 0)$store.dispatch('files/get',{fileId:identityWithInfo.entity.idDocumentFileId, namePrefix: identityWithInfo.entity.id + '_Identity' });"
                                            class="pa-1 ma-1 fill-height"
                                        >
                                            Identity Doc
                                            <br />
                                            <h3>
                                                <v-icon
                                                    color="success"
                                                    v-if="identityWithInfo.entity.idDocumentFileId"
                                                >mdi-check</v-icon>
                                                <v-icon
                                                    color="info"
                                                    v-else-if="identityWithInfo.entity.idDocumentAvailable"
                                                >mdi-alpha-a-circle</v-icon>
                                                <v-icon
                                                    color="error"
                                                    v-else
                                                >mdi-close</v-icon>
                                            </h3>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    ></v-col>
                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    ></v-col>

                                    <v-col
                                        class="text-center"
                                        cols="6"
                                        lg="3"
                                        md="4"
                                        xl="2"
                                    ></v-col>
                                </v-row>
                            </v-card-text>
                        </div>
                        <v-card-text>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-account</v-icon>
                                {{identityTypeName(identityWithInfo.entity.identityTypeId)}}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-if="identityWithInfo.entity.email"
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-at</v-icon>
                                {{identityWithInfo.entity.email}}
                            </v-chip>

                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-if="identityWithInfo.entity.phone"
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-phone-classic</v-icon>
                                {{identityWithInfo.entity.phone}}
                            </v-chip>

                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-if="identityWithInfo.entity.city"
                            >
                                <v-icon
                                    left
                                    small
                                >mdi-city-variant-outline</v-icon>
                                {{identityWithInfo.entity.city}}
                            </v-chip>
                            <v-chip
                                class="ma-1"
                                color="secondary"
                                dark
                                small
                                v-show="identityWithInfo.entity.verifiedRsaIdId > 0"
                            >                                <v-icon
                                    left
                                    small
                                >mdi-check</v-icon>Verified RSA Id</v-chip>
                        </v-card-text>
                        <!--<v-card-text class="pt-0">
                            Footer Text
                        </v-card-text>-->
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog
            persistent
            v-model="identityFormVisible"
            width="500px"
        >
            <IdentityForm
                :identity-in="identityFormIdentity"
                :identity-types="identityTypes"
                :key="identityFormKey"
                @close="closeIdentityForm"
                @deleted="deleteIdentity"
                @saved="updateIdentity"
            />
        </v-dialog>

        <!--<v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showFilters"
            width="350px"
        >
            <v-card>
                <v-card-title>Identity Filtering</v-card-title>
                <v-card-text>
                    <v-divider></v-divider>
                    <v-switch
                        @change="paginationDebounce(filterDebounceTime)"
                        class="mb-0"
                        label="Status"
                        v-model="filterOnStatus"
                    ></v-switch>
                    <v-select
                        :disabled="!filterOnStatus"
                        :items="statusOptions"
                        @change="paginationDebounce(filterDebounceTime)"
                        class="my-0"
                        item-text="name"
                        item-value="value"
                        style="max-width:200px"
                        v-model="filterStatus"
                    ></v-select>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="resetFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Reset</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="showFilters = !showFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                    >Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>-->
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500, true)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
//import Identity from "../models/Identity.model";
import uuid4 from "../helpers/uuid4";
//import { FilesUrl } from "../services/axios.service";
import Identity from "../models/Identity.model";
import IdentityForm from "../components/forms/IdentityForm";

export default {
    name: "Identities",
    props: ["status"],
    data: function() {
        return {
            //filesUrl: FilesUrl,
            //main data
            identitiesWithInfo: null,
            identityTypes: null,
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            totalMatches: null,
            searchString: "",
            orderBy: "",
            sortOrder: null,
            paginationTimeout: null,
            requestId: uuid4(),
            //form data
            //identityFormVisible: false,
            //identityFormKey: 0,
            //identityFormIdentity: new Identity()
            //filters
            showFilters: false,
            filterDebounceTime: 500,

            //form
            identityFormVisible: false,
            identityFormKey: 0,
            identityFormIdentity: new Identity()
        };
    },
    mounted: async function() {
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        this.getIdentities();
    },
    //activated: function(){//when keep a live is brought back up},
    components: {
        IdentityForm
        //
    },
    methods: {
        //DISPLAY METHODS
        identityTypeName(identityTypeId) {
            var type = this.identityTypes.find(x => x.key == identityTypeId);
            return type ? type.value : "Unknown Identity Type";
        },
        //GET METHODS
        getIdentities() {
            var requestId = (this.requestId = uuid4());
            this.$store
                .dispatch("identities/get", {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder
                    },
                    requestId: requestId
                })
                .then(identitiesResponse => {
                    if (this.requestId == identitiesResponse.requestId) {
                        this.identitiesWithInfo = identitiesResponse.data.page;
                        this.totalMatches = identitiesResponse.data.total;
                        this.pageSize = identitiesResponse.data.pageSize;
                        this.pageNo = identitiesResponse.data.pageNumber;
                        this.pagesCount = Math.ceil(
                            identitiesResponse.data.total / this.pageSize
                        );
                    }
                });
        },
        paginationDebounce(debounceTime, isPaging) {
            if (!isPaging) {
                this.pageNo = 1;
                this.pagesCount = 0;
            }
            if (this.identitiesWithInfo !== null)
                this.identitiesWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(
                this.getIdentities,
                debounceTime
            );
        },
        setSearch(value) {
            this.searchString = value;
            this.paginationDebounce(1000);
        },
        resetFilters() {
            this.filterOnStatus = false;
            this.filterStatus = 1;
            this.paginationDebounce(0);
        },

        //FORM METHODS---------------------------------
        newIdentity() {
            var identity = new Identity();
            identity.id = 0;
            this.loadIdentityForm(identity);
        },
        loadIdentityForm(identity) {
            this.identityFormIdentity = new Identity().set(identity);
            this.identityFormKey = identity.id;
            this.identityFormVisible = true;
        },
        closeIdentityForm() {
            this.identityFormVisible = false;
            this.identityFormIdentity = new Identity();
            this.identityFormKey = null;
        },
        updateIdentity() {
            this.paginationDebounce(0);
        },
        deleteIdentity() {
            this.paginationDebounce(0);
        }
    }
};
</script>

<style lang="stylus" scoped>
.entity-card
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content
        background-color: rgba(127, 127, 127, 0.15)

.pagination-bar
    // position: fixed;
    bottom: 0
    margin: auto
    left: 0
    right: 0
    padding-bottom: 0.1rem
    padding-top: 0.1rem
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */

.theme--light
    .base-background
        background: #FFFFFF

.theme--dark
    .base-background
        background: #121212
</style>